// extracted by mini-css-extract-plugin
export default {"myClaimsTable":"MyClaimsTable_myClaimsTable__50rkb","myClaimActions":"MyClaimsTable_myClaimActions__9FIa3","sortingIcon":"MyClaimsTable_sortingIcon__jI5W-"};